import React, {FC} from 'react';

import Box from '@material-ui/core/Box';
import {BoxProps, withStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../utils/ThemeUtils';

const StyledWrapper = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        position: 'relative',
        width: '100%',
        minWidth: 330
    }
}))(Box);

const StyledButton = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        position: 'absolute',
        borderRadius: '30%',
        width: 80,
        height: 40,
        left: getDirectionStyles(theme.direction)('50%', 'unset'),
        right: getDirectionStyles(theme.direction)('unset', '50%'),
        cursor: 'pointer',
        zIndex: 99
    }
}))(Box);

const CalendarHeaderButton: FC<BoxProps> = ({children, onClick}: BoxProps) => {
    return (
        <StyledWrapper>
            <StyledButton onClick={onClick} />
            {children}
        </StyledWrapper>
    );
};

export default CalendarHeaderButton;
